export const DIF_ZERO = 0;
export const ZERO = 0;
export const USER = 0;
